import styled from 'styled-components'

export const OftenBuyContainer = styled.div`
  width: 100%;
  display: grid;
  
  padding: 15px;
  padding-top: 34px;
  padding-bottom: 50px;
  margin-top: 26px;
  margin-bottom: 10px;
  
  @media screen and (min-width: 1100px) {
    padding-left: 0px;
    padding-right: 0px;
  }

`

export const OftenBuyTitle = styled.h2`
  font-size: 24px;
  font-family: ${props => props.theme.font.family.medium};
  font-weight: bold;
  color: black;
  margin-bottom: 24px;
  @media screen and (min-width: 1100px) {

  }


`

export const OftenBuyContent = styled.div`
  width: 100%;
  display: flex;
  background-color: #F7FAFC;
  border-radius: 10px;
  @media screen and (max-width: 1099px){
    flex-direction: column;
  }
  @media screen and (min-width: 1100px){
    padding: 20px;
    
  }
 
`

export const OftenBuyProducts = styled.div`
  @media screen and (min-width: 1100px){
    width: 60%;
    margin-right: 5%;
  }
  margin-bottom: 0;
`

export const OftenBuyProductItems = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 20px;

  .product-item {
    border-radius: 10px;
    height: 200px;
    &:not(:first-child) {
      &::before {
        margin-left:0;
        display: flex;
        align-items: center;
        justify-content: center;
        content: '+';
        font-size: 30px;
        height: 35px;
        width: 35px;
        background-color:#B2B2B2;
        border-radius: 100%;
        color: white;
        position: absolute;
        //left: 50%;
        //transform: translateX(-50%);
        //top: -38px;
        top: 50%;
        transform: translateY(-50%);
        left: -28px;
      }
    }
  }
  @media screen and (min-width: 1100px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-gap: 45px;
    .product-item {
      height: auto;
      &:not(:first-child) {
        &::before {
          height: 28px;
          width: 28px;
          margin-left: -10px;
          font-size: 40px;
          top: 50%;
          transform: translateY(-50%);
          left: -28px;
        }
      }
    }
  }

`

export const OftenBuyProductNames = styled.div`
  margin-top: 24px;
  a {
    font-size: 14px;
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black2};
    display: flex;
    text-decoration: none;
    &:not(:first-child) {
      margin-top: 24px;
    }
    i{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .check {
      width: 23px;
      height: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      fill: ${props => props.theme.color.red};
      border-radius: 6px;
      border: 3px solid ${props => props.theme.color.red};
      margin-right: 8px;
    }

    &.checked {
      font-family: ${props => props.theme.font.family.regular};
      color: ${props => props.theme.color.black2};

      .check {
        border-color: #DFE3E9;
        svg {
          fill: #DFE3E9;
        }
      }
    }
  }
  padding-bottom: 25px;
  border-bottom: 1px solid #DCDFE2;
  @media screen and (min-width: 1100px) {

  }



`

export const OftenBuyRightSide= styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  @media screen and (min-width: 1100px){
    width: auto;
  }
`

export const OftenBuySummery = styled.div`
  
  display: flex;
  justify-content: space-around;
  
  p {
    font-size: 16px;
    color: ${props => props.theme.color.black2};
  }
  h3 {
    font-size: 30px;
    color: ${ props => props.theme.color.red};
    font-family: ${props => props.theme.font.family.medium};
    font-weight: bolder;
    margin: 5px 0 0;
  }

  button {
    margin-top: 0px;
    margin-left: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60%;
    font-size: 16px;
    svg {
      margin-right: 13px;
      height: 25px;
      width: 25px;
    }
  }
  @media screen and (min-width: 1100px) {
    justify-content: space-between;
    button{
      width: 300px;

    }
  }
  @media screen and (max-width: 1100px) {
    margin-top: 25px;
`

  export const OftenBuyPrice = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    text-align: left !important;
    p{
      text-align: left;
    }
  `


